import styled from 'styled-components';

const Text = styled.p`
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallBold}
  color: ${({ theme }) => theme.colors.night_blue_1};
  margin: 0;
  text-align: center;
`;

export default Text;
